import router from './router'
import { checkLogined, checkBound } from '@/utils/login'
import { noLoginPages } from '@/utils/constant'
import { isInWX } from '@/utils/utils'
import store from '@/store'

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title;
  if (noLoginPages.includes(to.name)) {
    next()
    return
  }
  const hasLogined = process.env.BUILD_ENV === 'dev' ? true : checkLogined()
  let nextParam;
  if (hasLogined) {
  // if (checkLogined()) {
    // 未绑定
    if (!checkBound() && to.name !== 'Binding') {
      nextParam = {
        name: 'Binding',
        replace: true
      }
    } else {
      // 如果无用户信息，查询用户信息
      const userInfo = store.getters.userInfo;
      if (!userInfo || !Object.keys(userInfo).length) {
        await store.dispatch('getUserInfo')
      }
    }
  } else {
    // 未登录
    if (to.name !== 'Init') {
      nextParam = {
        name: 'Init',
        replace: true
      }
    }
  }
  next(nextParam);
})